import { Badge } from "@/components/ui/badge";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type BadgeCellProps = {
  list: string[];
  limit?: number;
};

export const BadgeCell = ({ list, limit }: BadgeCellProps) => {
  const ArrayList = Array.isArray(list) ? list : [];
  const displayList = limit ? ArrayList.slice(0, limit) : ArrayList;
  const remainingCount =
    limit && ArrayList.length > limit ? ArrayList.length - limit : 0;

  return ArrayList.length > 0 ? (
    <span className="flex items-center gap-1 flex-wrap">
      {displayList.map((item: string, index: number) => (
        <Badge key={index} variant="outline">
          {item}
        </Badge>
      ))}
      {remainingCount > 0 ? (
        <Tooltip>
          <TooltipTrigger>
            <span className="text-primary font-bold">(+{remainingCount})</span>
            <TooltipContent className="w-80">
              {ArrayList.join(", ")}
            </TooltipContent>
          </TooltipTrigger>
        </Tooltip>
      ) : null}
    </span>
  ) : null;
};
